<template>
<div class="coupon-wrapper" :class="{'disabled': disabled}">

	<div class="header">
		<img v-if="disabled" src="../../../assets/img-v2/ic_coupon_logo_gray.png" class="icon" />
		<img v-else src="../../../assets/img-v2/ic_coupon_logo.png" class="icon" />
		<div class="info">
			<div class="name">{{ dataSource.couponTemplateName }}</div>
			<div class="valid">有效期至 {{ dataSource.endDate | dateTime }}</div>
		</div>
		<div v-if="type !== 2" class="value">
			<span class="unit">￥</span>
			<span>{{ fenToYuan(dataSource.money) }}</span>
		</div>
	</div>
	<div v-if="!disabled" class="footer">
		<div class="line"></div>
		<template v-if="!disabled">
			<div class="label" @click="onClick">
				<div class="text">使用规则</div>
				<img src="../../../assets/img-v2/ic_coupon_arrow_down.png" :class="{reverse: collapsed}" class="arrow" />
			</div>
			<div class="desc" v-if="collapsed" v-html="dataSource.couponExplain"></div>
		</template>
	</div>
</div>
</template>

<script>

import { fenToYuan } from '@/utils';

export default {
	name: 'couponCard',
	props: {
		active: {
			type: [Number, String],
		},
		dataSource: {
			type: Object,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			collapsed: false,
		};
	},
	computed: {
		id() {
			return 'id' in this.dataSource && this.dataSource.id;
		},
		type() {
			return this.dataSource.type;
		},
	},
	watch: {
		dataSource() {
			this.render();
		},
		active(newVal) {
			if (newVal) {
				this.render(newVal);
			}
		},
	},
	filters: {
		dateTime(val) {
			return val && val.substr(0, 10);
		},
	},
	mounted() {},
	methods: {
		fenToYuan,
		onClick() {
			this.$emit('on-click', this.id);
		},
		render(id = null) {
			this.collapsed = id === this.id ? !this.collapsed : false;
		},
	},
};
</script>

<style lang="scss" scoped>
.coupon-wrapper {
	background: #ffffff;
	border-radius: 12px;
	box-shadow: 0px 0px 4px 0px #D7E3EA;
	margin-bottom: 10px;
	.header {
		position: relative;
		z-index: 10;
		display: flex;
		align-items: center;
		padding: 16px 14px;
	}
	.icon {
		width: 32px;
		height: 32px;
		margin-right: 12px;
	}
	.info {
		flex: 1;
	}
	.name {
		font-family: PingFangSC, PingFang SC;
		font-weight: 500;
		font-size: 16px;
		color: #000000;
		line-height: 22px;
	}
	.valid {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 14px;
		color: #999999;
		line-height: 20px;
	}
	.value {
		font-family: DINAlternate, DINAlternate;
		font-weight: bold;
		font-size: 28px;
		color: #FE5959;
		line-height: 32px;
	}
	.unit {
		font-family: DINAlternate, DINAlternate;
		font-weight: bold;
		font-size: 14px;
		color: #FE5959;
		line-height: 16px;
		margin-right: 4px;
	}
	
	.footer {
		position: relative;
		padding: 10px 14px;
	}
	
	.label {
		display: flex;
		align-items: center;
	}
	.text {
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 12px;
		color: #A2A2A2;
		line-height: 17px;
	}
	.arrow {
		width: 12px;
		height: 12px;
		margin-left: 8px;
	}
	.reverse {
		transform: rotateZ(180deg);
	}
	
	.desc {
		font-size: 12px;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		line-height: 17px;
	}
	.line {
		position: absolute;
		top: 0;
		left: 14px;
		right: 14px;
		border-top: 1px dashed #eeeeee;
		display: flex;
		justify-content: center;
		&::before {
			content: '';
			position: absolute;
			left: -20px;
			top: -6px;
			width: 12px;
			height: 12px;
			background: #F3F4F5;
			border-radius: 50%;
		}
		&::after {
			content: '';
			position: absolute;
			right: -20px;
			top: -6px;
			width: 12px;
			height: 12px;
			background: #F3F4F5;
			border-radius: 50%;
		}
	}
}
.disabled {
	.name {
		color: #999999!important;
	}
	.valid {
		color: #BBBBBB;
	}
	.unit {
		color: #999999;
	}
	.value {
		color: #999999;
	}
}
</style>
<style>
.desc ol {
  list-style: decimal !important;;
}
</style>
